export default __webpack_public_path__ + "static/media/adgroup.25d1a0b3.svg";